export const LANG_ALIASES = {
    'ar': 'uae',
    'ae': 'uae',
    'ir': 'uae',
    'sa': 'uae',
    'eg': 'uae',
    'jo': 'uae',
    'iq': 'uae',
    'sy': 'uae',
    'lb': 'uae',
    'cn': 'zh',
    'tw': 'zh',
    'hk': 'zh',
    'sg': 'zh',
    'us': 'gb',
    'fa': 'ar',
};

export function resolveNarrationLang(lang, available) {
    const l = lang.toLowerCase();
    if (available.includes(l)) return l;
    const alias = LANG_ALIASES[l];
    if (alias && available.includes(alias)) return alias;
    return available[0];
}
